import React from "react";
import { IImageSettingsControlProps, ImageSettingsControl } from "../image-control/image-settings-control";

interface IImageBrightnessProps extends IImageSettingsControlProps{}

export const ImageBrightnessControl = React.memo((props: IImageBrightnessProps) => {
  return <ImageSettingsControl {...props} label={"Helligkeit"} />;
});
